// extracted by mini-css-extract-plugin
module.exports = {"container":"popup_container__S42qK","button":"popup_button__1wSG8","list":"popup_list__xtp80"};